export enum VehicleTypeEnum {
  Car = 'car',
  Motorcycle = 'motorcycle',
}
